import { TextArea } from "formsy-semantic-ui-react";
import React from "react";
import classes from './Preview.module.css'

export default function Preview(props){
    const AboutUsRendering = () => {
        if( props.fullAiData.AboutUs){
            let about = "";
            props.fullAiData.AboutUs.forEach(element => {
                element = (element && typeof element === 'string') ? JSON.parse(element) : element;
                if(element.skip === undefined ){
                    if(element.a.trim() != ""  ){
                        let question = element.q.split("?");
                        let Q = "<h4>"+question[0]+"?"+"</h4>";
                        let a = element.a.trim();
                        about += Q+a;
                    }
                }else if(element.skip === false ){
                    if(element.a.trim() != ""  ){
                        let question = element.q.split("?");
                        let Q = "<h4>"+question[0]+"?"+"</h4>";
                        let a = element.a.trim();
                        about += Q+a;
                    }
                }
            });
            return (<><div dangerouslySetInnerHTML={{__html: about}}/></>)
        }else{
            return (<></>);
        }
    }
    const ServiceesProvide = () => {
        if(props.fullAiData.BuisnessCat){
            let services = "";
            let subServices = props.fullAiData.BuisnessCat.subCatDeata.filter( mainCat =>  {
                if(mainCat.name){
                    return mainCat.name;
                }
            } ).map((ser => ser.name)).join("<br/>");
            let titletext = subServices != "" ? "<strong>What services do we offer?  </strong>" : "";
            let additioncategory = "";
            if(props.fullAiData.BuisnessCat.additionCategories && props.fullAiData.BuisnessCat.additionCategories.trim()){
                additioncategory = props.fullAiData.BuisnessCat.additionCategories;
            }
            let arrayForm = additioncategory.split("\n");
            services = titletext+"<br/>"+subServices+"<br/>"+arrayForm.join("<br/>");
            return (<><div dangerouslySetInnerHTML={{__html: services}}/></>)
        }else{
            return (<></>);
        }
    }

   
    const ExcludedServices = () => {
        let excudedSer = "";
        if(props.fullAiData.BuisnessCat){
            props.fullAiData.BuisnessCat.subCatDeata.map( (even => {
                if(even.checked)
                excudedSer += even.name + ". <br/>";
            }) )
            excudedSer += props.fullAiData.BuisnessCat.additionCategories;
             return (<><div dangerouslySetInnerHTML={{__html: excudedSer}}/></>)
        }else{
            return (<></>)
        }
    }
    const FaqPreview = () => {
        if(props.fullAiData.YourFAQA){
            let faqs = "<br/>";
            props.fullAiData.YourFAQA.forEach(element => {
                element = (element && typeof element === 'string') ? JSON.parse(element) : element;
                if(element.a.trim() != ""){
                    let question = element.q.split("?");
                    let answer = element.a.trim();
                    let arrayForm = answer.split("\n");
                    faqs += "<strong>Question : "+question[0]+"?</strong>"+"<br> Answer: "+arrayForm.join("<br/> ")+"<br/><br/>";
                }
            });
            let additonFaq = "";
            if(props.fullAiData.AdditonalFaqContext ){
                let arrayForm = props.fullAiData.AdditonalFaqContext.split("\n");
                additonFaq = arrayForm.join("<br/> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp");
            }
            return (<><div dangerouslySetInnerHTML={{__html: faqs}}/>
            <div dangerouslySetInnerHTML={{__html: additonFaq}}/></>)
        }else{
            return (<></>)
        }
    }
    let conversationGoal = "";
    if(props.fullAiData.conversationGoal){
        let arrayForm = props.fullAiData.conversationGoal.split("\n");
        conversationGoal = arrayForm.join("<br/> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp");
    }

    let companyOverview = "";
    if(props.fullAiData.companyOverview){
        let arrayForm = props.fullAiData.companyOverview.split("\n");
        companyOverview = `<strong>Company Overview : </strong>`+arrayForm.join("<br/> &nbsp&nbsp&nbsp&nbsp&nbsp&nbsp");
    }
    
    const SquadDisplay = () => {

        if (props.fullAiData.squad_setting) {            
            return(
                <div className="row" style={{marginTop: 10}}>
                <div className="col-md-12">
                    <h4>Squad setting</h4>
                </div>    
                {props.fullAiData.squad_setting.length && props.fullAiData.squad_setting.map((squad) => (
                    <div className="col-md-5" style={{padding: 8, margin: 10, border: '1px solid #dee2e6',borderRadius: 8, boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.05)'}}>
                        <h4><strong>Assistant name:</strong> {squad.assistantName}</h4>
                        <strong>Message:</strong> {squad.message} <br /> <br />
                        <strong>Description:</strong> {squad.description}
                    </div>
                ))}
                </div>
            )
        }else{
            return(
                <div></div>
            )
        }        
    }

    function getCurrentDateTime(data) {
        if(data.timezone === undefined){
            return "";
        }
        console.log(JSON.stringify(data));
        // Helper to get "st", "nd", "rd", "th" suffix
        function getOrdinalSuffix(day) {
          if (day > 3 && day < 21) return 'th';
          switch (day % 10) {
            case 1: return 'st';
            case 2: return 'nd';
            case 3: return 'rd';
            default: return 'th';
          }
        }
      
        // Month names array
        const months = [
          "January", "February", "March", "April", "May", "June",
          "July", "August", "September", "October", "November", "December"
        ];
      
        // Extract UTC offset from the timezone string (e.g., "(UTC-07:00)")
        const utcOffsetMatch = data.timezone.match(/\(UTC([+-]\d{2}):(\d{2})\)/);
      
        if (!utcOffsetMatch) {
          return "Invalid timezone format.";
        }
      
        const offsetHours = parseInt(utcOffsetMatch[1], 10);
        const offsetMinutes = parseInt(utcOffsetMatch[2], 10);
      
        // Get current UTC time
        const now = new Date();
        const utcTime = now.getTime() + (now.getTimezoneOffset() * 60000);
      
        // Apply timezone offset
        const timezoneTime = new Date(utcTime + (offsetHours * 60 + offsetMinutes) * 60000);
      
        // Format the time
        let hours = timezoneTime.getHours();
        const minutes = timezoneTime.getMinutes();
        const ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // 0 => 12 in 12-hour clock
      
        const formattedDate = `The current date and time is ${months[timezoneTime.getMonth()]} ${timezoneTime.getDate()}${getOrdinalSuffix(timezoneTime.getDate())} at ${hours}:${minutes.toString().padStart(2, '0')}${ampm}`;
      
        return formattedDate;
    }

    return (
        <>
            <div className={`${classes.posR}`}>
                <div
                className={`${classes.previewSection}`}
                dangerouslySetInnerHTML={{__html: conversationGoal}}
                />
                 <span 
                className={`${classes.editIconPreview} ${classes.editIconPreviewConversation}` }
                ><i class="la la-edit"
                title="Click to edit."
                onClick={(e) => props.sethandleConfusedClick(e,5)}
                ></i></span>
            </div>
                
           
                
            <div className={`${classes.previewSection}`} >   
            <h4>Information about the company is below:</h4>
                {
                    (props.fullAiData.companyInfo?.timeVariable !== undefined && props.fullAiData.companyInfo?.timeVariable === 'ON')&& <span>
                        {getCurrentDateTime(props.fullAiData.companyInfo)}<br/>
                    </span>
                }
                Company name : {props.fullAiData.companyInfo && props.fullAiData.companyInfo.companyName}<br/>
                Company phone number : {props.fullAiData.companyInfo && props.fullAiData.companyInfo.phoneNumber}<br/>
                Maximum no. of response per word : {props.fullAiData.companyInfo && props.fullAiData.companyInfo.limit}<br/>

                {props.bot_type == 'Voice_Turbo' && <SquadDisplay />}
                <span 
                className={`${classes.editIconPreview}`}
                ><i class="la la-edit"
                title="Click to edit."
                onClick={(e) => props.sethandleConfusedClick(e,1)}
                ></i></span>
            </div>

            {props.workspace_version !== 'v2' && (
  <div className={`${classes.previewSection}`}>
    <AboutUsRendering />
    <span 
      className={`${classes.editIconPreview}`}
    >
      <i 
        className="la la-edit"
        title="Click to edit."
        onClick={(e) => props.sethandleConfusedClick(e, 3)}
      ></i>
    </span>
  </div>
)}

            <div className={`${classes.posR}`}>
                </div>
                {props.workspace_version !== 'v2' && (
  <div className={`${classes.previewSection}`} style={{ position: 'relative' }}>
    <div dangerouslySetInnerHTML={{ __html: companyOverview }} />
    <span
      className={`${classes.editIconPreview} ${classes.editIconPreviewConversation}`}
      onClick={(e) => props.sethandleConfusedClick(e, 2)}
    >
      <i className="la la-edit" title="Click to edit." />
    </span>
  </div>
)}

            {props.workspace_version !== 'v2' && (
            <div className={`${classes.previewSection}`}>
                <strong>Context to exclude : </strong>
                <ExcludedServices/>
            </div>
            )}
            
            <div className={`${classes.previewSection}`}
            >
                                <strong>{props.workspace_version == 'v2' ? 'FAQs and business info :' :'FAQs :'} </strong>

                <FaqPreview/>
                <span 
                className={`${classes.editIconPreview}`}
                ><i class="la la-edit"
                title="Click to edit."
                onClick={(e) => props.sethandleConfusedClick(e,4)}
                ></i></span>
            </div>
        </>
    )
}